import React from "react";
import { Swipeable } from "react-swipeable";
import Icon from "@material-ui/core/Icon/Icon";
import _, { divide } from "lodash";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../Icons";
import Button from "@material-ui/core/Button/Button";

import "./Styles.scss";
import PropTypes from "prop-types";

class Carousel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    vertical: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  constructor(props) {
    super(props);
    this.state = {
      slidesToShow: 0,
      containerWidth: 0,
      containerHeight: 0,
      firstIndex: 0,
      offsetLeft: 0,
      offsetTop: 0,
      prevActive: false,
      nextActive: false,
      showArrows: false,
      hover: null,
      touch: null,
    };
    this.children = [];
  }

  componentDidMount() {
    this.init();
    const { carousel } = this.refs;
    const wheelEventName = "onwheel" in carousel ? "wheel" : "mousewheel";
    carousel.addEventListener(wheelEventName, this.scrolled);
  }

  componentDidUpdate() {
    // waiting for the browser to apply css changes..
    setTimeout(() => this.init(), 100);
  }

  init = () => {
    if (!this.slider || !this.slider.children) {
      return;
    }
    this.children = this.slider.children;
    const { vertical } = this.props;
    const { container } = this.refs;
    const { carousel } = this.refs;
    const cc = getComputedStyle(container);
    const ph = parseInt(cc.paddingLeft) + parseInt(cc.paddingRight);
    const pv = parseInt(cc.paddingTop) + parseInt(cc.paddingBottom);
    const cw =
      (container.clientWidth > 0
        ? container.clientWidth
        : carousel.clientWidth) - ph;
    const ch =
      (container.clientHeight > 0
        ? container.clientHeight
        : carousel.clientHeight) - pv;
    let width = 0;
    let height = 0;
    let containerWidth = 0;
    let containerHeight = 0;
    // TODO: read xl value
    const arrowSize = container.clientWidth >= 1920 ? 30 : 28;
    let slidesToShow = 0;
    let idx = 0;
    let offsetLeft = 0;
    let offsetTop = 0;
    for (let c = 0; c < this.children.length; c++) {
      // IE 11 needs this..
      if (!this.children[c]) {
        continue;
      }
      const item = this.children[c];
      if (vertical) {
        height += item.offsetHeight;
        if (ch >= height) {
          slidesToShow++;
          containerHeight = height;
        }
        containerWidth = Math.max(containerWidth, item.offsetWidth);
        if (idx < this.state.firstIndex) {
          offsetTop = -height;
        }
      } else {
        width += item.offsetWidth;
        if (cw >= width) {
          slidesToShow++;
          containerWidth = width;
        }

        containerHeight = Math.max(containerHeight, item.offsetHeight);

        if (idx < this.state.firstIndex) {
          offsetLeft = -width - 38;
        }
      }
      idx++;
    }
    if (this.state.firstIndex + slidesToShow > this.children.length) {
      this.setState({ firstIndex: this.children.length - slidesToShow });
      return;
    }
    const nextActive =
      this.state.firstIndex + slidesToShow < this.children.length;
    const prevActive = this.state.firstIndex > 0;
    const showArrows = this.children.length !== slidesToShow;
    if (!showArrows) {
      offsetTop = offsetLeft = 0;
    }
    const arrowFromTop =
      containerHeight > arrowSize ? containerHeight - arrowSize - 12 : 0;
    const state = {
      ...this.state,
      slidesToShow,
      containerWidth,
      containerHeight,
      offsetLeft,
      offsetTop,
      prevActive,
      nextActive,
      showArrows,
      arrowSize,
      arrowFromTop,
    };
    if (!_.isEqual(state, this.state)) {
      this.setState(state);
    }
  };

  next = () => {
    const { firstIndex, slidesToShow } = this.state;
    if (firstIndex + slidesToShow < this.children.length) {
      this.setState({ firstIndex: this.state.firstIndex + 1 });
    } else {
      //  this.setState({ firstIndex: 0 });
    }
  };

  prev = () => {
    const { firstIndex } = this.state;
    if (firstIndex > 0) {
      this.setState({ firstIndex: firstIndex - 1 });
    } else {
      // this.setState({ firstIndex: this.children.length - 1 });
    }
  };

  swiped = (e, deltaX, deltaY) => {
    // if it's vertical deltaY should be the bigger
    if (this.props.vertical && Math.abs(e.deltaY) >= Math.abs(e.deltaX)) {
      if (e.deltaY > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
    // if it's not vertical deltaX should be the bigger
    else if (!this.props.vertical && Math.abs(e.deltaX) >= Math.abs(e.deltaY)) {
      if (e.deltaX > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  };

  scrolled = (e) => {
    e.preventDefault();
    if (e.deltaX > 0 || e.deltaY < 0 || e.wheelDelta > 0) {
      this.prev();
    } else {
      this.next();
    }
  };

  onHover = (which) => {
    this.setState({ hover: which });
    if (which === null) {
      this.setState({ touch: null });
    }
  };

  onTouch = (which) => {
    this.setState({ touch: which });
  };

  render() {
    const {
      containerWidth,
      containerHeight,
      offsetLeft,
      offsetTop,
      prevActive,
      nextActive,
      showArrows,
      arrowFromTop,
      hover,
      touch,
    } = this.state;
    const className = [
      "carousel-wrapper",
      this.props.className,
      this.props.vertical ? "vertical" : "horizontal",
      showArrows ? "content-overflow" : "content-fit",
    ].join(" ");
    const prevClassName = [
      "carousel-nav",
      "prev",
      prevActive ? "active" : "",
    ].join(" ");
    const nextClassName = [
      "carousel-nav",
      "next",
      nextActive ? "active" : "",
    ].join(" ");
    const style = {
      height: containerHeight,
      /* containerHeight */ /* containerHeight */ width: "100%",
    };

    return (
      <div className={className} ref="container">
        <div className="carousel" ref="carousel" style={style}>
          {showArrows && (
            <ArrowLeftIcon
              className={prevClassName}
              disabled={!prevActive}
              style={{ top: arrowFromTop }}
              onClick={this.prev}
              onHover={prevActive && hover === "left"}
              onPressed={prevActive && touch === "left"}
              onMouseEnter={() => this.onHover("left")}
              onMouseLeave={() => this.onHover(null)}
              onTouchStart={() => this.onTouch("left")}
              onTouchLeave={() => this.onTouch(null)}
              onMouseDown={() => this.onTouch("left")}
              onMouseUp={() => this.onTouch(null)}
            />
          )}
          <Swipeable
            className="carousel-frame"
            trackMouse
            onSwiping={this.swiping}
            onSwiped={this.swiped}
          >
            <div
              className="carousel-slider"
              style={{
                left: offsetLeft,
                top: 0,
                /* offsetTop */ /* offsetTop */ width: !showArrows
                  ? "100%"
                  : "auto",
              }}
              ref={(slider) => (this.slider = slider)}
            >
              {React.Children.map(this.props.children, (element) => (
                <div style={{ display: "inline-block", width: "auto" }}>
                  {element}
                </div>
              ))}
            </div>
          </Swipeable>
          {showArrows && (
            <ArrowRightIcon
              disabled={!nextActive}
              style={{ top: arrowFromTop }}
              onClick={this.next}
              className={nextClassName}
              onHover={nextActive && hover === "right"}
              onPressed={nextActive && touch === "right"}
              onMouseEnter={() => this.onHover("right")}
              onMouseLeave={() => this.onHover(null)}
              onTouchStart={() => this.onTouch("right")}
              onTouchLeave={() => this.onTouch(null)}
              onMouseDown={() => this.onTouch("right")}
              onMouseUp={() => this.onTouch(null)}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Carousel;
